<template>
    <div>
        <b-modal
            size="md"
            v-model="modalShow"
            :title="`${$locale.patient}区分を追加`"
            ok-title="追加"
            ok-variant="yokumiru-orange"
            cancel-title="キャンセル"
            cancel-variant="yokumiru-gray"
            :ok-disabled="inProgress"
            :cancel-disabled="inProgress"
            @ok="handleOk"
            @cancel="close"
            @hidden="close">
            <form @submit.stop.prevent="add">
                <div class="row">
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label for="name">{{ $locale.patient }}区分名</label>
                            <input v-model="user_category.name"
                                   id="name"
                                   class="form-control m-input"
                                   :class="{ 'is-invalid' : errors.name }"
                                   type="text">

                            <div class="invalid-feedback d-block mt-1" v-if="errors.name">
                                {{ errors.name[0]}}
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label for="name_kana">{{ $locale.patient }}区分名（カナ）</label>
                            <input v-model="user_category.name_kana"
                                   id="name_kana"
                                   class="form-control m-input"
                                   :class="{ 'is-invalid' : errors.name_kana }"
                                   type="text">

                            <div class="invalid-feedback d-block mt-1" v-if="errors.name_kana">
                                {{ errors.name_kana[0]}}
                            </div>
                        </div>
                    </div>
                </div>
            </form>

            <div slot="modal-footer" class="w-100" :class="{ 'u-loader u-loader--sm' : inProgress }">
                <button
                    class="btn btn-yokumiru-orange float-right"
                    :disabled="inProgress"
                    @click="handleOk">
                    追加
                </button>

                <button
                    class="btn btn-yokumiru-gray float-right mr-2"
                    :disabled="inProgress"
                    @click="close">
                    キャンセル
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import constants from '../../../constants'

    export default {
        data: function () {
            return {
                inProgress: false,
                modalShow: false,
                user_category: {
                    name: null,
                    name_kana: null,
                },
                errors: {},
            }
        },

        created: function () {
            bus.$on('open-modal-add-user-category', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-add-user-category')
        },

        methods: {
            /**
             * モーダル表示
             */
            open: function () {
                this.modalShow = true
            },

            init: function () {
                this.user_category = {
                    name: null,
                    name_kana: null,
                }
            },

            /**
             * 追加ボタン押下時
             *
             * @param {object} e
             */
            handleOk: function (e) {
                e.preventDefault()
                this.add()
            },

            /**
             * 患者区分追加
             */
            add: async function () {
                if (this.inProgress) return
                this.inProgress = true

                await axios.post(constants.admin.user_categories.endpoint.add, this.user_category)
                    .then(() => {
                        bus.$emit('alert-success', `${this.$locale.patient}区分を追加しました。`)
                        bus.$emit('fetch-user-categories')
                        this.close()
                    })
                    .catch(({response}) => {
                        bus.$emit('alert-danger')
                        if (response.data.errors) {
                            this.errors = response.data.errors
                        }
                    })

                this.inProgress = false
            },

            /**
             * モーダルを閉じる
             */
            close: function () {
                this.init()
                this.errors = {}
                this.modalShow = false
            },
        },
    }
</script>
